// extracted by mini-css-extract-plugin
export default {"ticketsStatusContent":"TicketsStatus_ticketsStatusContent__7yCyU","info":"TicketsStatus_info__vz6WC","dot":"TicketsStatus_dot__gkATO"};